import { render, staticRenderFns } from "./commonDimensionsDialog.vue?vue&type=template&id=51441cc7&scoped=true&"
import script from "./commonDimensionsDialog.vue?vue&type=script&lang=js&"
export * from "./commonDimensionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51441cc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51441cc7')) {
      api.createRecord('51441cc7', component.options)
    } else {
      api.reload('51441cc7', component.options)
    }
    module.hot.accept("./commonDimensionsDialog.vue?vue&type=template&id=51441cc7&scoped=true&", function () {
      api.rerender('51441cc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/commonDimensionsDialog.vue"
export default component.exports